module.exports = __webpack_public_path__ + "static/media/maria.ac230069.jpg";